<template>
  <div class="competencies__wrapper">
    <vtitle />

    <div class="competencies">
      <div class="left-panel">
        <h1>{{ $tr('vacancy.preferences.competences.settings.properties') }}</h1>
        <div class="nrow">
          <div class="nrow">
            <h2>{{ $tr('vacancy.preferences.competences.settings.shape.title') }}</h2>

            <div
              v-for="option in availableCompetenciesView"
              :key="option.id"
              class="competencies__option"
              :disabled="isNull(view)"
            >
              <input :id="option.name" v-model="view" type="radio" :value="option.id" />

              <label :for="option.name"> </label>

              <span>{{ $tr(`vacancy.preferences.competences.settings.shape.${option.name}`) }}</span>
            </div>
          </div>

          <div class="nrow">
            <h2>{{ $tr('vacancy.preferences.competences.settings.count.title') }}</h2>

            <div
              v-for="option in availableCompetenciesLevel"
              :key="option.id"
              class="competencies__option"
              :disabled="isNull(level)"
            >
              <input :id="option.name" v-model="level" type="radio" :value="option.id" />

              <label :for="option.name"> </label>

              <span>{{ option.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="right-panel">
        <competencies-list v-model="competencies" class="comp-list" />
      </div>
    </div>

    <div class="row-block row-block-last button-wrapper">
      <vbutton :label="'vacancy.preferences.competences.newSection'" color="grey" icon="plus" @click="newCompetence" />

      <div>
        <vbutton
          class="vacancy-button"
          label="common.save"
          color="white"
          :loading="loading"
          :disabled="is_disabled || loading"
          @click="save(false)"
        />

        <vbutton
          class="vacancy-button"
          label="vacancy.saveAndContinue"
          :loading="loading"
          :disabled="is_disabled || loading"
          @click="save(true)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CompetenciesList from './List.vue';
import vtitle from '@/routes_new/inner/vacancy/components/vtitle.vue';

const DEFAULT_VIEW_ID = 1;
const DEFAULT_LEVEL_ID = 1;

export default {
  name: 'PreferencesCompetencies',

  components: {
    CompetenciesList,
    vtitle
  },

  props: {
    vacancyId: {
      type: [String, Number],
      default: ''
    }
  },

  data() {
    return {
      loading: false
    };
  },

  computed: {
    availableCompetenciesView() {
      return this.availableCompetencies ? this.availableCompetencies.view : null;
    },

    availableCompetenciesLevel() {
      return this.availableCompetencies ? this.availableCompetencies.level : null;
    },

    availableCompetencies() {
      return this.$store.getters['vacancy/availableCompetencies'];
    },

    view: {
      get() {
        return this.firstCompetence && this.firstCompetence.view ? this.firstCompetence.view.id : null;
      },

      set(val) {
        this.updateCompetencies({ view: { id: val } });
      }
    },

    level: {
      get() {
        return this.firstCompetence && this.firstCompetence.level ? this.firstCompetence.level.id : null;
      },

      set(val) {
        this.updateCompetencies({ level: { id: val } });
      }
    },

    firstCompetence() {
      return this.competencies && this.competencies.length ? this.competencies[0] : null;
    },

    competencies: {
      get() {
        return this.$store.getters['vacancy/competencies'];
      },

      set(competencies) {
        competencies = competencies.map((competence, i) => ({ ...competence, sort_order: i }));

        this.$store.commit('vacancy/updateCompetencies', competencies);
      }
    },

    is_disabled() {
      if (!this.competencies || !this.competencies.length) {
        return false;
      }

      return this.competencies.some(item => item.name.length === 0);
    }
  },

  beforeMount() {
    this.fetch();
  },

  methods: {
    newCompetence() {
      const competence = {
        name: '',
        view: {
          id: this.isNull(this.view) ? DEFAULT_VIEW_ID : this.view
        },

        level: {
          id: this.isNull(this.level) ? DEFAULT_LEVEL_ID : this.level
        }
      };
      this.$store.commit('vacancy/createCompetence', competence);
    },

    updateCompetencies(paramObj) {
      const competences = this.competencies.map(competence => ({ ...competence, ...paramObj }));

      this.$store.commit('vacancy/updateCompetencies', competences);
    },

    fetch() {
      return Promise.all([
        this.$store.dispatch('vacancy/fetchAvailableCompetencies', { id: this.vacancyId }),
        this.$store.dispatch('vacancy/fetchCompetencies', { id: this.vacancyId })
      ]);
    },

    isNull(v) {
      return v === undefined || v === null;
    },

    save(is_continue = 'false') {
      this.loading = true;
      this.$store
        .dispatch('vacancy/saveCompetencies')
        .then(() => {
          this.loading = false;
          this.$noty.success(this.$tr('vacancy.preferences.modals.saveSuccess.text')); // уточнить текст для сохранения настроек компетенций
          if (window.gtag) {
            window.gtag({ event: 'competence_creation' });
          }
          if (is_continue) {
            this.$router.push({ path: `/vacancies/${this.vacancyId}/accesses` });
          }
        })
        .catch(() => {
          this.loading = false;
          this.$noty.error(this.$tr('vacancy.preferences.modals.saveFailure.text')); // уточнить текст для ошибки сохранения настроек компетенций
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.competencies {
  display: flex;
  width: 100%;
  flex-direction: column;
  padding-top: 4px;

  &__wrapper {
    max-width: 700px;
  }
  .left-panel {
    padding: 0 0 30px;

    h1,
    h2 {
      padding: 0;
      margin: 0;
    }

    h1 {
      @include mixin-text-header-big;
      margin-bottom: 14px;
    }

    h2 {
      margin: 0;
      margin-right: 20px;
      font-weight: 500;
      font-size: 18px;
      line-height: 26px;
      color: #233346;
    }

    .competencies__option + .competencies__option {
      margin-left: 19px;
    }

    .competencies__option {
      position: relative;
      display: flex;
      align-items: center;
      span {
        padding-left: 10px;
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 22px;
        color: #233346;
      }
    }
  }

  .right-panel {
    width: 100%;

    .vcv-button {
      margin-top: 24px;
      margin-left: 20px;
    }
  }
}
.row-block {
  margin: 25px 0;
}
.row-block-last {
  margin: 50px 0 100px;
}
.nrow {
  display: flex;
  margin-right: 68px;

  & h2 {
    padding: 0;
  }
}
.competencies .left-panel h2 {
  @include mixin-text-header;
  padding: 0 !important;
  margin-right: 20px !important;
}

.button-wrapper {
  display: flex;
  justify-content: space-between;
  .vacancy-button:not(:last-child) {
    margin-right: 10px;
  }
}

.comp-list {
  margin-bottom: 24px;
}
</style>
